import { defaultAxios } from '@/services/index';

const typeformService = {
  async createTypeformInfo(code: string, wa: string, redirect_uri: string) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${wa}/typeform/authenticated`,
        { code, redirect_uri },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getTypeformInfo(alias: string) {
    try {
      const res = await defaultAxios.get(`/workspaces/${alias}/typeform/`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteTypeformInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/typeform/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default typeformService;
